import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import { useNavigate } from 'react-router-dom';
import SelectGrid from './add/SelectGrid';
import Basic from './add/Basic';
import Location from './forms/Location';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  appBar: {
    position: 'fixed',
    margin: '0 auto',
  }
}));

function getSteps() {
  return ['Category', 'Type', 'Location'];
}



export default function AddSign(props) {
    const {api, user, organization} = props;
    const navigate = useNavigate();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [catFilter, setCatFilter] = React.useState(null);
 // const [signType, setSignType] = React.useState(null);
  const [sign, setSign] = React.useState({
    owner : (user && user.id ? user.id : 0), 
    organization : (organization && organization.id ? organization.id : 0)
    });
  const steps = getSteps();
  const [loaded, setLoaded] = React.useState(false);
  const [typesList, setTypesList] = React.useState([]);
  //const [bTypesList, setBTypesList] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [saving, setSaving] = React.useState(false);
  //console.log('user', user, 'org', organization);
  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        if(catFilter) setCatFilter(null);
        return (<SelectGrid items={categories} onClick={handleChooseCat} />);
      case 1:
        return (<SelectGrid items={catFilter ? typesList.filter(n => n.opt_cat === catFilter) : typesList} onClick={handleChooseType} />);
      case 2:
        return (
        <React.Fragment>
            <Basic sign={sign} user={user} onChange={updateSign} />
            <Location sign={sign} onChange={updateSign} />
        </React.Fragment>
        );
      default:
        return 'Howd you get here!?';
    }
  }
  
  const handleChooseCat = (item) => {
    setCatFilter(item.id);
    handleNext();
  }
  const handleChooseType = (item) => {
    //setSignType(item.id);
    updateSign({
        id: 'new',
        sign_type: item.id,
        sign_type_obj: item,
        location: sign.location || item.name+' on Street',
        description: sign.description || item.description+' by '+user.name,
        timeZone: sign.timeZone || user.timezone,
    });
    handleNext();
  }

  const updateSign = (data) => {
    //console.log('new sign props', Object.assign({}, sign, data));
    setSign((oldval) => Object.assign({}, oldval, data));
  }

  React.useEffect(() => {
    if(!loaded){
        getTypesList();
    }
});
  const getTypesList = () =>{
    setLoaded(true);
    api({
        vso: 'typeslist'
    }, (data) => {
        setTypesList(data.types);
        //setBTypesList(data.btypes);
        setCategories(data.categories);
        //setImages(data.images);
    });
}
const handleSave = (e) => {
    setSaving(true);
    console.log("Save button clicked!");
    api({
        vso: 'sign',
        sign: Object.assign({}, sign, {
            id: null,
            owner: user.id,
            organization: organization.id
        }),
        subaction: 'save'
    }, (data) => {
        console.log(data);
        setSaving(false);
        //setChanged(false);
        //setSaveLabel('Save Sign');
        setSign(data.sign);
        if(data.sign.id){
            navigate('/sign/'+data.sign.id+'/details');
        }
        //navigate to sign
    });
}

  const handleNext = () => {
    if(activeStep === steps.length - 1){
        //save the sign
        return handleSave();
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <React.Fragment>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <Typography className={classes.instructions}>All steps completed</Typography>
            <Button onClick={handleReset}>Reset</Button>
          </div>
        ) : (
          <div>
            {getStepContent(activeStep)}
            <AppBar position="relative" color="default">
                <Box display="flex">
              <Button
                disabled={activeStep === 0}
                onClick={handleBack}
                className={classes.backButton}
              >
                Back
              </Button>
              <Box flexGrow={1} />
              <Button variant="contained" color="primary" onClick={handleNext} disabled={saving}>
                {activeStep < 2 ? 'Skip' : activeStep === steps.length - 1 ? 'Finish' : 'Next'}
              </Button>
              </Box>
            </AppBar>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
